import { useEffect, useState } from "react";
import imagePath from "../../constants/imagePath";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { _onOpenCloseContactUsPage } from "../../redux/reducers/setting";
import {
  AIDevelopment,
  AppDevelopment,
  Automotive,
  CloseIcon,
  DigitalMarketing,
  Ecommerce,
  EcommerceSlider,
  Education,
  Finance,
  Fintech,
  GameDevelopment,
  Government,
  Healthcare,
  Logistics,
  MarkLogo,
  MediaEntertainment,
  MenuIcon,
  MobileApp,
  OnDemand,
  PlusIcon,
  ProductEngineering,
  RealEstate,
  RightArrow,
  SoftwareDevelopment,
  Sports,
  TravelHospitality,
  WebDevelopment,
} from "../../constants/svgPath";
import ContactUs from "../Popup/ContactUs";
import {
  headerServiceDetailsLinks,
  HeaderServiceKey,
} from "../../utils/ServiceData";

function CaretDown({ className = "" }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      className={className}
      focusable="false"
    >
      <path
        d="M6.75 9.75L12 15l5.25-5.25"
        fill="none"
        stroke="#d8d8d8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function Header() {
  const isTouchDevice =
    typeof window !== "undefined" &&
    window.matchMedia("(hover: hover)").matches &&
    !("ontouchstart" in window);

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState<string | null>(null);
  const [scrolled, setScrolled] = useState(false);
  const [selectedService, setSelectedService] = useState<HeaderServiceKey>(
    "mobile_app_development",
  );
  const handleToggle = (menuName: string) => {
    setOpenMenu((prev) => (prev === menuName ? null : menuName));
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const burger = document.querySelector(".header__burger");
    const navWrapper = document.querySelector(".header__navigation-wrapper");

    if (burger && navWrapper) {
      burger.addEventListener("click", () => {
        burger.classList.toggle("active");
        navWrapper.classList.toggle("open");
      });
    }

    const listItems = document.querySelectorAll(".gt-nav__item.has-submenu");

    listItems.forEach((item) => {
      item.addEventListener("click", () => {
        if (window.innerWidth > 1025) return;

        item.classList.toggle("active");

        const submenuWrapper = item.querySelector(
          ".submenu-wrapper",
        ) as HTMLElement;

        if (submenuWrapper) {
          if (submenuWrapper.style.maxHeight) {
            submenuWrapper.style.maxHeight = "";
          } else {
            submenuWrapper.style.maxHeight = `${submenuWrapper.scrollHeight}px`;
          }
        }
      });
    });

    window.addEventListener("resize", () => {
      if (window.innerWidth <= 1025) {
        document
          .querySelectorAll(".gt-nav__item.has-submenu.active")
          .forEach((item) => {
            const submenuWrapper = item.querySelector(
              ".submenu-wrapper",
            ) as HTMLElement | null;
            if (submenuWrapper) {
              submenuWrapper.style.maxHeight = `${submenuWrapper.scrollHeight}px`;
            }
          });
      } else {
        document.querySelectorAll(".submenu-wrapper").forEach((wrapper) => {
          (wrapper as HTMLElement).style.maxHeight = "";
        });
      }
    });

    document.querySelectorAll('a[href="#"]').forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
      });
    });
  }, []);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isPopupOpen) {
      document.body.classList.add("body_active");
    } else {
      document.body.classList.remove("body_active");
    }
  }, [isPopupOpen]);

  return (
    <>
      <header className={`gt-header ${scrolled ? "scrolled" : ""}`}>
        <div className="contair gt-header__inner">
          {/* Left: Brand */}
          <Link
            to="/"
            className="gt-brand"
            aria-label="Girips Technologies home"
          >
            <MarkLogo />
          </Link>
          <div className="menu_btn_mn">
            {!open && (
              <button className="menuopen" onClick={() => setOpen(true)}>
                <MenuIcon />
              </button>
            )}

            {/* Close Button */}
            {open && (
              <button className="close-btn" onClick={() => setOpen(false)}>
                <CloseIcon />
              </button>
            )}
          </div>
          {/* <button className="menuopen" onClick={() => setOpen(true)} > <MenuIcon /> </button>
<button className="close-btn" onClick={() => setOpen(false)}> X </button> */}

          {/* Center: Navigation */}
          <nav
            aria-label="Primary"
            className={`gt-nav mobile-menu ${open ? "open" : ""}`}
          >
            <ul className="gt-nav__list">
              <li className="gt-nav__item nav_hover">
                <div className="gt-menu">
                  {/* <Link to="/industries" className="gt-link drp_anhr">
                    Industries
                  </Link> */}
                  <Link
                    to=""
                    className="gt-link drp_anhr"
                    onClick={(e) => {
                      e.preventDefault();
                      handleToggle("industries");
                    }}
                  >
                    Industries
                  </Link>

                  <div
                    className={`gt-menu__list ${
                      openMenu === "industries" ? "is-open" : ""
                    }`}
                  >
                    <ul className="menu__list" role="menu">
                      <li className="logi_lst">
                        <Link
                          className="gt-menu__link"
                          to={`/industries/finance-banking`}
                          role="menuitem"
                          onClick={() => setOpen(false)}
                        >
                          <div className="icon_menu">
                            <Finance color="#D6AA56" />
                          </div>
                          <div className="icon_txt">
                            <h3>
                              Finance/Banking <PlusIcon />
                            </h3>
                            <p>
                              Enterprise banking systems ensuring compliance,
                              security, and financial stability.
                            </p>
                          </div>
                        </Link>
                      </li>

                      <li className="ondm_lst">
                        <Link
                          className="gt-menu__link"
                          to={`/industries/on-demand`}
                          role="menuitem"
                          onClick={() => setOpen(false)}
                        >
                          <div className="icon_menu">
                            {" "}
                            <OnDemand color={"#15C1D4"} />{" "}
                          </div>
                          <div className="icon_txt">
                            <h3>
                              {" "}
                              On-Demand <PlusIcon />
                            </h3>
                            <p>
                              Custom on-demand apps connecting users with
                              instant local services seamlessly.
                            </p>
                          </div>
                        </Link>
                      </li>

                      <li className="heal_lst">
                        <Link
                          className="gt-menu__link"
                          to={`/industries/healthcare`}
                          role="menuitem"
                          onClick={() => setOpen(false)}
                        >
                          <div className="icon_menu">
                            <Healthcare />
                          </div>
                          <div className="icon_txt">
                            <h3>
                              Healthcare <PlusIcon />
                            </h3>
                            <p>
                              HIPAA-compliant healthcare platforms improving
                              patient care through secure digital solutions.
                            </p>
                          </div>
                        </Link>
                      </li>

                      <li className="trav_lst">
                        <Link
                          className="gt-menu__link"
                          to={`/industries/travel-hospitality`}
                          role="menuitem"
                          onClick={() => setOpen(false)}
                        >
                          <div className="icon_menu">
                            {" "}
                            <TravelHospitality color={"#FC6A6A"} />{" "}
                          </div>
                          <div className="icon_txt">
                            <h3>
                              {" "}
                              Travel & Hospitality <PlusIcon />
                            </h3>
                            <p>
                              Smart travel apps simplifying bookings,
                              itineraries, and guest experiences worldwide.
                            </p>
                          </div>
                        </Link>
                      </li>
                      <li className="real_lst">
                        <Link
                          className="gt-menu__link"
                          to={`/industries/real-estate`}
                          role="menuitem"
                          onClick={() => setOpen(false)}
                        >
                          <div className="icon_menu">
                            {" "}
                            <RealEstate color="#396CA3" />{" "}
                          </div>
                          <div className="icon_txt">
                            <h3>
                              {" "}
                              Real Estate <PlusIcon />
                            </h3>
                            <p>
                              Innovative real estate platforms for seamless
                              buying and selling experiences online.
                            </p>
                          </div>
                        </Link>{" "}
                      </li>
                      <li className="edu_lst">
                        <Link
                          className="gt-menu__link"
                          to={`/industries/education`}
                          role="menuitem"
                          onClick={() => setOpen(false)}
                        >
                          <div className="icon_menu">
                            {" "}
                            <Education color="#834C87" />
                          </div>{" "}
                          <div className="icon_txt">
                            <h3>
                              {" "}
                              Education <PlusIcon />
                            </h3>
                            <p>
                              Interactive e-learning solutions enhancing digital
                              classrooms and student engagement globally.
                            </p>
                          </div>
                        </Link>
                      </li>

                      <li className="logi_lst">
                        <Link
                          className="gt-menu__link"
                          to={`/industries/logistics`}
                          role="menuitem"
                          onClick={() => setOpen(false)}
                        >
                          <div className="icon_menu">
                            <Logistics />
                          </div>
                          <div className="icon_txt">
                            <h3>
                              Logistics <PlusIcon />
                            </h3>
                            <p>
                              Robust logistics software optimizing supply chains
                              and fleet operations in real-time.
                            </p>
                          </div>
                        </Link>
                      </li>

                      <li className="medi_lst">
                        <Link
                          className="gt-menu__link"
                          to={`/industries/media-entertainment`}
                          role="menuitem"
                          onClick={() => setOpen(false)}
                        >
                          <div className="icon_menu">
                            {" "}
                            <MediaEntertainment />{" "}
                          </div>
                          <div className="icon_txt">
                            <h3>
                              {" "}
                              Media & Entertainment <PlusIcon />
                            </h3>
                            <p>
                              Engaging media apps delivering immersive content
                              and streaming experiences across platforms.
                            </p>
                          </div>
                        </Link>
                      </li>
                      <li className="medi_lst">
                        <Link
                          className="gt-menu__link"
                          to={`/industries/ecommerce`}
                          role="menuitem"
                          onClick={() => setOpen(false)}
                        >
                          <div className="icon_menu">
                            {" "}
                            <EcommerceSlider color={"#39A36C"} />{" "}
                          </div>
                          <div className="icon_txt">
                            <h3>
                              {" "}
                              eCommerce <PlusIcon />
                            </h3>
                            <p>
                              Scalable ecommerce solutions driving conversions
                              and personalized shopping journeys worldwide.
                            </p>
                          </div>
                        </Link>
                      </li>
                      <li className="medi_lst">
                        <Link
                          className="gt-menu__link"
                          to={`/industries/government`}
                          role="menuitem"
                          onClick={() => setOpen(false)}
                        >
                          <div className="icon_menu">
                            {" "}
                            <Government color="#49B3B8" />{" "}
                          </div>
                          <div className="icon_txt">
                            <h3>
                              {" "}
                              Government <PlusIcon />
                            </h3>
                            <p>
                              Secure government systems enabling transparent,
                              efficient public services for citizens nationwide.
                            </p>
                          </div>
                        </Link>
                      </li>
                      <li className="medi_lst">
                        <Link
                          className="gt-menu__link"
                          to={`/industries/automotive`}
                          role="menuitem"
                          onClick={() => setOpen(false)}
                        >
                          <div className="icon_menu">
                            {" "}
                            <Automotive color="#B0BF1F" />{" "}
                          </div>
                          <div className="icon_txt">
                            <h3>
                              {" "}
                              Automotive(Auto-Mobile) <PlusIcon />
                            </h3>
                            <p>
                              Smart automotive solutions enhancing mobility,
                              safety, and connected vehicle experiences.
                            </p>
                          </div>
                        </Link>
                      </li>
                      <li className="medi_lst">
                        <Link
                          className="gt-menu__link"
                          to={`/industries/fintech`}
                          role="menuitem"
                          onClick={() => setOpen(false)}
                        >
                          <div className="icon_menu">
                            {" "}
                            <Fintech color="#72B849" />{" "}
                          </div>
                          <div className="icon_txt">
                            <h3>
                              {" "}
                              Fintech <PlusIcon />
                            </h3>
                            <p>
                              Next-gen financial apps redefining payments,
                              lending, and digital wealth.
                            </p>
                          </div>
                        </Link>
                      </li>
                      <li className="medi_lst">
                        <Link
                          className="gt-menu__link"
                          to={`/industries/sports`}
                          role="menuitem"
                          onClick={() => setOpen(false)}
                        >
                          <div className="icon_menu">
                            {" "}
                            <Sports color={"#CF7700"} />{" "}
                          </div>
                          <div className="icon_txt">
                            <h3>
                              {" "}
                              Sports <PlusIcon />
                            </h3>
                            <p>
                              Dynamic sports apps for fan engagement, analytics,
                              and live experiences.
                            </p>
                          </div>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>

              <li className="gt-nav__item nav_hover">
                <div className="gt-menu">
                  {/* <Link to="/services"
                   className="gt-link drp_anhr">Services
                </Link> */}

                  <Link
                    to=""
                    className="gt-link drp_anhr"
                    onClick={(e) => {
                      e.preventDefault();
                      handleToggle("services");
                    }}
                  >
                    Services
                  </Link>

                  <div
                    className={`gt-menu__list ${
                      openMenu === "services" ? "is-open" : ""
                    }`}
                  >
                    <ul className="menu__list" role="menu">
                      <li
                        className="logi_lst"
                        onClick={() =>
                          setSelectedService("mobile_app_development")
                        }
                      >
                        <a className="gt-menu__link" href="#" role="menuitem">
                          <div className="icon_menu">
                            <MobileApp />
                          </div>
                          <div className="icon_txt">
                            <h3>
                              Mobile App Development <PlusIcon />
                            </h3>
                            <p>
                              Innovative, user-friendly mobile apps tailored to
                              your business needs.
                            </p>
                          </div>
                        </a>
                      </li>
                      <li
                        className="real_lst"
                        onClick={() => setSelectedService("digital_marketing")}
                      >
                        <a className="gt-menu__link" href="#" role="menuitem">
                          <div className="icon_menu">
                            {" "}
                            <DigitalMarketing />
                          </div>{" "}
                          <div className="icon_txt">
                            <h3>
                              {" "}
                              Digital Marketing <PlusIcon />{" "}
                            </h3>
                            <p>
                              Data-driven strategies to enhance online
                              visibility, engagement, and growth.
                            </p>
                          </div>
                        </a>
                      </li>

                      <li
                        className="ondm_lst"
                        onClick={() =>
                          setSelectedService("eCommerce_development")
                        }
                      >
                        <a className="gt-menu__link" href="#" role="menuitem">
                          <div className="icon_menu">
                            {" "}
                            <Ecommerce />{" "}
                          </div>
                          <div className="icon_txt">
                            <h3>
                              {" "}
                              eCommerce Development <PlusIcon />
                            </h3>
                            <p>
                              Custom eCommerce platforms designed for seamless
                              shopping experiences.
                            </p>
                          </div>
                        </a>
                      </li>
                      <li
                        className="ai_lst"
                        onClick={() => setSelectedService("cloud_engineering")}
                      >
                        <a className="gt-menu__link" href="#" role="menuitem">
                          <div className="icon_menu">
                            {" "}
                            <AIDevelopment />{" "}
                          </div>
                          <div className="icon_txt">
                            <h3>
                              {" "}
                              Cloud Engineering <PlusIcon />
                            </h3>
                            <p>
                              Advanced Cloud Engineering driving automation,
                              insights, and efficiency.
                            </p>
                          </div>
                        </a>
                      </li>
                      <li
                        className="medi_lst"
                        onClick={() =>
                          setSelectedService("on_demand_app_development")
                        }
                      >
                        <a className="gt-menu__link" href="#" role="menuitem">
                          <div className="icon_menu">
                            {" "}
                            <AppDevelopment />{" "}
                          </div>
                          <div className="icon_txt">
                            <h3>
                              {" "}
                              On-Demand App Development <PlusIcon />
                            </h3>
                            <p>
                              Scalable on-demand solutions tailored for instant
                              service delivery.
                            </p>
                          </div>
                        </a>
                      </li>
                      <li
                        className="edu_lst"
                        onClick={() =>
                          setSelectedService("product_engineering")
                        }
                      >
                        <a className="gt-menu__link" href="#" role="menuitem">
                          <div className="icon_menu">
                            {" "}
                            <ProductEngineering />{" "}
                          </div>
                          <div className="icon_txt">
                            <h3>
                              Product Engineering <PlusIcon />
                            </h3>
                            <p>
                              End-to-end product development from ideation to
                              market success.
                            </p>
                          </div>
                        </a>
                      </li>
                      <li
                        className="wb_lst"
                        onClick={() => setSelectedService("staff_augmentation")}
                      >
                        <a className="gt-menu__link" href="#" role="menuitem">
                          <div className="icon_menu">
                            {" "}
                            <WebDevelopment />{" "}
                          </div>
                          <div className="icon_txt">
                            <h3>
                              {" "}
                              Staff Augmentation <PlusIcon />
                            </h3>
                            <p>
                              Empower your business by adding the right talent
                              at right time
                            </p>
                          </div>
                        </a>{" "}
                      </li>
                    </ul>

                    <div className="right_menu">
                      <h3>
                        {headerServiceDetailsLinks[selectedService].title}
                      </h3>
                      <ul>
                        {headerServiceDetailsLinks[selectedService].links?.map(
                          (link) => {
                            return (
                              <li>
                                <Link
                                  to={`/services/${link.slug}`}
                                  onClick={() => setOpen(false)}
                                >
                                  <RightArrow /> {link?.link}
                                </Link>
                              </li>
                            );
                          },
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </li>

              {/* <li className="gt-nav__item"> */}
              {/* <Link to="/case-studies" className="gt-link">
                Case- Studies
              </Link> */}
              {/* <Link to="" className="gt-link">
                  Case-Studies
                </Link>
              </li> */}
              <li className="gt-nav__item">
                <Link to="" className="gt-link">
                  News & Insights
                </Link>
              </li>
              <li className="gt-nav__item gt-lst_second">
                <Link
                  to="/about"
                  className="gt-link"
                  onClick={() => setOpen(false)}
                >
                  About Us
                </Link>
                {/* <Link to="/"  className="gt-link">
                About Us
              </Link> */}
              </li>
              <li className="gt-nav__item btn_mbl">
                <button
                  type="button"
                  onClick={() => setIsPopupOpen(true)}
                  className="btn_common btn_primry"
                >
                  Contact Us
                </button>
              </li>
            </ul>
          </nav>
          {/* Right: CTA */}
          <div className="gt-cta">
            <a
              className="gt-cta__button"
              type="button"
              onClick={() => setIsPopupOpen(true)}
            >
              Contact Us
            </a>
          </div>
        </div>
      </header>
      <ContactUs isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </>
  );
}
